<form [formGroup]="datiGeneraliForm" (ngSubmit)="save();">
  <app-dati-generali-fascicolo-common [request]="request" [fascicolo]="fascicolo" [inserimento]="inserimento" [datiGeneraliForm]="datiGeneraliForm" (changedFondoRischiState)="changedFondoRischiState()"></app-dati-generali-fascicolo-common>
  <app-protocol-fascicolo-form [fascicolo]="fascicolo" (protocolDataChange)="onDataProtocol($event)" [dataView]="protocollo" />
  <div class="row container_fieldset">
   <div class="col-sm-12">
    <fieldset class="form-group">
      <legend>Precetto di riferimento</legend>
      <div textInput class="col-sm-3" [labelInput]="'Posizione'"
           formControlName="posizioneFascicoloRif"
           [(ngModel)]="request.fascicolo.posizioneFascicoloRif"></div>
      <div textInput class="col-sm-3"
           [labelInput]="'N&deg; ruolo/decreto'"
           formControlName="numRuoloDecretoRif"
           [(ngModel)]="request.fascicolo.numRuoloDecretoRif"></div>
      <div datePickerInput class="col-sm-3" [labelInput]="'Data apertura'"
           formControlName="dataInizioFascicoloRif"
           [(ngModel)]="request.fascicolo.dataInizioFascicoloRif"></div>
      <div textInputCurrency [control]="datiGeneraliForm.controls['valorePrecettoRiferimento']"
           class="col-sm-3" [labelInput]="'Valore'" [location]="'SezioneEconomica'"
           formControlName="valorePrecettoRiferimento"
           [(ngModel)]="request.fascicolo.valorePrecetto"></div>
    </fieldset>
   </div>
  </div>
  <div class="row container_fieldset">
   <div class="col-sm-12">
    <fieldset class="form-group">
      <legend>Pignoramento</legend>

      <div checkBoxRadio class="col-sm-6"
           [labelInput]="'Conversione del pignoramento'"
           idInput="'conversionePignoramento'"
           formControlName="conversionePignoramento"
           [(ngModel)]="request.fascicolo.conversionePignoramento"
           (onReturn)="request.fascicolo.conversionePignoramento= $event"></div>

      <div datePickerInput class="col-sm-6"
           [labelInput]="'Data trascrizione nel registro immobliare'"
           formControlName="dataTrascrizioneRegistroImm"
           [control]="datiGeneraliForm.controls['dataTrascrizioneRegistroImm']"
           [(ngModel)]="request.fascicolo.dataTrascrizioneRegistroImm"></div>

    </fieldset>
   </div>
  </div>
  <div class="row">
    <div textAreaInput class="form-group col-xs-12 col-sm-12"
         [labelInput]="'Note'" formControlName="note"
         [(ngModel)]="request.fascicolo.note"></div>
  </div>

  <div>
    <h3 class="title1level">Campi personalizzati</h3>
        <app-fascicolo-metadata-form *ngIf="!fascicolo.id && fascicolo.tipoFascicolo.id"
          [tipoFascicolo]="fascicolo.tipoFascicolo.id"
          (metadataListChange)="onRetrieve($event)"
          (formChange)="isFormMetadataValid($event)">
        </app-fascicolo-metadata-form>
        <app-fascicolo-metadata-form *ngIf="fascicolo.id && fascicolo.tipoFascicolo.id"
          [fascicolo]="request.fascicolo"
          (metadataListChange)="onRetrieve($event)"
          (formChange)="isFormMetadataValid($event)">
        </app-fascicolo-metadata-form>
  </div>

  <div class="row">
    <p class="mandatory col-sm-12">
      <em>* Campi obbligatori</em>
    </p>
  </div>

  <div
    *ngIf="checkFondoRischiRemoved && !request.fascicolo.flagFondoRischi"
    class="row">
    <div class="col-sm-12 form-group">
      <p *ngIf="checkFondoRischiRemoved" confermaCambioFr #confermaCambioFrModifica (onReturn)="notifyConferma($event)"></p>
    </div>
  </div>

  <div [ngClass]="minervaWizard ? 'wizard-buttons' : ''" class="row">
    <p class="col-sm-3 col-xs-6">
      <button type="button" class="btn btn-outline-secondary btn-block"
              (click)="resetForm.emit()">Reset</button>
    </p>
    <p submitButton
       class="col-sm-3 col-xs-6 col-sm-offset-6"
       [labelButton]="minervaWizard ? 'Prosegui' : 'Salva'"
       [disabled]=" (checkFondoRischiRemoved && !request.fascicolo.flagFondoRischi ? !confermaFrChangeChecked : false) ||
								( (changeFondoRischi && !request.fascicolo.dataVariazioneFondoRischi) && ( !inserimento ) && ( !wizard ) ) ||
														!datiGeneraliForm.valid || !metadataFormValid"></p>
  </div>
</form>
